import { FC, ReactElement } from 'react';

import { Icon } from '../../../../components';
import { Button } from '../../../../compositions';
import { useTrans } from '../../../../hooks';

import './DesktopMainNavigationToggle.scss';

interface DesktopMainNavigationToggleProps {
    isDisabled: boolean;
    label?: string;
    onClick: () => void;
    className?: string;
}

export const DesktopMainNavigationToggle: FC<DesktopMainNavigationToggleProps> = ({
    isDisabled,
    label,
    onClick,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    return (
        <Button
            text={label || trans('containers.menu.productNavigationLabel')}
            disabled={isDisabled}
            onClick={onClick}
            className={`desktop-main-navigation-toggle ${className}`}
            labelClassName="desktop-main-navigation-toggle__label-wrapper"
        >
            <Icon name="hamburger" className="desktop-main-navigation-toggle__hamburger-icon" />

            <span className="desktop-main-navigation-toggle__label">
                {label}
            </span>
        </Button>
    );
};
